/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum JobRequestFileCategory {
    SOURCE_DOCUMENT = 'SOURCE_DOCUMENT',
    REFERENCE = 'REFERENCE',
    TRANSLATED_DOCUMENT = 'TRANSLATED_DOCUMENT',
    QUOTE_CONFIRMATION_DOCUMENT = 'QUOTE_CONFIRMATION_DOCUMENT',
    AI_POST_EDITED = 'AI_POST_EDITED',
    OTHER = 'OTHER',
}
